import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { baseQueryWithReauth } from "@states/auth/auth.api";
import { SLIDER_MANAGEMENT } from "@utils/constants/slider-management/slider-management.constants";

export const sliderApi = createApi({
  reducerPath: "sliderApi",
  tagTypes: ["Slider"],
  baseQuery: baseQueryWithReauth,
  // baseQuery: fetchBaseQuery({
  //     baseUrl: getBaseUrl(),
  // }),
  endpoints: (builder) => ({
    getAllSlider: builder.query<
      [],
      { page?: number; limit?: number; brand_name?: string }
    >({
      query: ({ page = 1, limit = 10, brand_name }) => {
        const queryParams = {
          url: SLIDER_MANAGEMENT.GET_ALL,
          params: { page, limit },
        };

        if (brand_name) {
          //@ts-ignore
          queryParams.params.brand_name = brand_name;
        }

        return queryParams;
      },
    }),
    createSlider: builder.mutation({
      query: (body) => ({
        url: SLIDER_MANAGEMENT.CREATE,
        method: "POST",
        body,
      }),
    }),
    updateSlider: builder.mutation({
      query: ({ id, body }) => ({
        url: `${SLIDER_MANAGEMENT.UPDATE}${id}`,
        method: "PATCH",
        body,
      }),
    }),
    deleteSlider: builder.mutation({
      query: (id) => ({
        url: `${SLIDER_MANAGEMENT.DELETE}${id}`,
        method: "DELETE",
      }),
    }),
  }),
  keepUnusedDataFor: 0,
});

export const {
  useGetAllSliderQuery,
  useCreateSliderMutation,
  useUpdateSliderMutation,
  useDeleteSliderMutation,
} = sliderApi;
